

export default class PushMessagesDetailsResponse {
    constructor(supportedLocales) {
        this.translations = [];
        this.createDate = null;
        this.publishDate = null;
        this.id = null;
        this.status = null;
        this.sendNotificationToAll = null;
        this.sendNotificationToSelected = null;
        this.selectedProfessionalStatuses = [];
        this.selectedAge = [];
        this.selectedLivingPlaces = [];
        this.publishedToCompanies = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                title: '',
                description: null,
            };
        });
        this.supportedLocales = supportedLocales;
    }

    static assign(from, to) {
        if (from) {
            to.id = from.id;
            to.createDate = from.createDate; 
            to.publishDate = from.publishDate ? new Date(from.publishDate) : null; 
            to.status = from.status;
            to.sendNotificationToAll = from.sendNotificationToAll;
            to.sendNotificationToSelected = from.sendNotificationToSelected;
            to.proffesionalStatus = from.proffesionalStatus;
            to.selectedProfessionalStatuses = from.selectedProfessionalStatuses;
            to.selectedAge = from.selectedAge;
            to.selectedLivingPlaces = from.selectedLivingPlaces;
            to.publishedToCompanies = from.publishedToCompanies || [];
            to.age = from.age;
            to.photo = from.photo;
            to.livingPlace = from.livingPlace;
            to.supportedLocales.forEach((element) => {
                to.translations[element] = {
                    title: from.translations[element]?.title,
                    description: from.translations[element]?.description,
                };
            });
        } else {
            to = new PushMessagesDetailsResponse();
        }
    }

    static copy(to, from) {
        PushMessagesDetailsResponse.assign(from, to);
        return to;
    }
}
